import selector from "./selector";

export const mapStateToProps = state => selector(state);
